<ng-container *ngComponentOutletNew="slides[type?.controlName || '']; outputs: outputs; inputs: { rules: rules, question: _question }"></ng-container>
